import { UNBINDING_CLEAR, UNBINDING_UPDATE } from '../mutationTypes';

const initState = {
  showAreaCode: false,
  showLatter: false,
  disabledSubmit: false,
  formModels: {
    areaCode: '+1',
    drivingLicense: [],
    email: '',
    identity: [],
    phone: '',
    realName: '',
    vin: '',
    agree: false,
  },
};
const state = {
  ...JSON.parse(JSON.stringify(initState)),
};
const getters = {};
const mutations = {
  // 清除
  [UNBINDING_CLEAR](states, newValue = initState) {
    const newState = JSON.parse(JSON.stringify(newValue));
    Object.assign(states, newState);
  },
  // 更新
  [UNBINDING_UPDATE](states, newValue = initState) {
    const newState = JSON.parse(JSON.stringify(newValue));
    Object.assign(states, newState);
  },
};
const actions = {};

export default {
  state,
  getters,
  mutations,
  actions,
};
